import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import "LIBRARY/Components/StockVerification/ImportStock/importStock.css";
import LibraryApiCall from 'LibraryApiCall';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as XLSX from "xlsx";

class ImportStock extends Component {
    constructor(props) {
        super(props)
        this.tableObject = {};
        this.myRef = React.createRef();
        this.state = {
            importStockModal: false,
            tabs: [
                { name: "Choose Excel File" },
                { name: "Start Import" }
            ],
            currentTab: 0,

            csvData: [],
            postStockDetailsArray: [],
            postStockHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                errors: [],
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
                verificationHistory: {}
            },

            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},
            fullScreen: false,

            errorMessageObjArray: [],
            preRequisiteFileName: 'Prerequisite Data.csv',

            //PreRequisite data
            preRequisiteCSVDataForFaculty: [
                { accessionSeries: '' },
            ],

            preRequisiteData: [],

            preRequisiteCSVHeadersForFaculty: [
                { label: "Accession Series ", key: "accessionSeries" }
            ],

            preRequisiteHeaders: [],
            loadingImportStockProcess: false,

            isImportButtonDisabled: false,

            accessionSeriesList: {},
            loadingAccessionSeriesData: false,

            // import Stock data state
            ImportaccessionSeriesList: {},
            loadingImportAccessionSeriesData: false,

            selectedStockVerification: "",
            stockScannedStockApiResponse: {},
            isAlreadyScanned: false
        }
    }

    componentDidMount() {
        this.setState({
            importStockModal: this.props.isShowImportStockButton,
            isImportButtonDisabled: false,
            selectedStockVerification: this.props.selectedStockVerification
        })

        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty

        // API Call for pre-requisite data
        this.apiCallToGetAccessionSeries(); // accession series

        // API Call for import Stock data
        this.ImportapiCallToGetAccessionSeries(); // accession series

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }

    // API Call For Pre-Requisite START

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeriesData: true });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeriesData: false
                });
            }
        }
    }
    // API Call Pre-Requisite END

    // API Call Import START

    //API CALL METHOD TO GET ACCESSION SERIES
    ImportapiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeriesData: true });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeriesData: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeriesData: false
                });
            }
        }
    }
    // API Call Import END

    closeImportStockModal = () => {
        this.setState({
            importStockModal: false,
            currentTab: 0,

            csvData: [],
            postStockDetailsArray: [],
            postStockHeadersArray: [],
            selectedCSVFiles: {},
            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            verifiedData: [],
            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},

        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        // const fileInput = document.getElementById("react-csv-reader-input");
        const fileInput = document.getElementById("react-excel-reader-input-Stock");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        };

        this.props.closeImportModalForStocks();
    }

    // OPEN FILE
    openFileInput = () => {
        document.getElementById("react-excel-reader-input-Stock").click();
    }

    // REMOVE SELECTED CSV FILE
    removeCSVFile = () => {
        this.setState({
            selectedCSVFiles: {},
            csvData: [],
            postStockDetailsArray: [],
            postStockHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            verifiedData: [],
        });

        const fileInput = document.getElementById("react-excel-reader-input-Stock");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        }
    }

    // Import Stock Modal
    importStockModal = () => {
        let resultFailedData = this.state.postStockDetailsArray.filter((item) => item.importStatus == 'failed')
        let resultSuccessData = this.state.postStockDetailsArray.filter((item) => item.importStatus == 'success')
        let resultPendingData = this.state.postStockDetailsArray.filter((item) => item.importStatus == 'pending')

        return (
            <>
                <div className={this.state.importStockModal ? 'modal fade show' : 'modal'} style={{ display: this.state.importStockModal ? "block" : 'none', visibility: this.state.importStockModal ? 'visible' : 'hidden' }}>
                    <div class="modal-dialog modal-lg--userdetails modal-dialog-centered" style={{ maxWidth: this.state.fullScreen ? '100vw' : '60vw', margin: this.state.fullScreen ? "0px auto" : "auto" }}>
                        <div class="modal-content modal-dialog-scrollable modal_content">
                            <div class="modal-header modal_header">
                                <h5 class="modal-title" style={{ textAlign: 'left' }} id="exampleModalLabel">Import Stock Details</h5>
                                {this.state.loadingImportStockProcess || this.state.loadingImportProcess ?
                                    null :
                                    <>
                                        <div style={{ display: "flex", flexDirection: "row", gap: "15px" }}>
                                            <button style={{ all: 'unset', cursor: "pointer" }} onClick={() => {
                                                this.setState({
                                                    fullScreen: !this.state.fullScreen
                                                })
                                            }}>
                                                {
                                                    this.state.fullScreen ?
                                                        (
                                                            <span>
                                                                <span style={{ border: '2px solid #000 !important', padding: '2px' }} title={"Compress Edit Mode"}><FontAwesomeIcon icon={['fas', 'compress-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                            </span>
                                                        ) :
                                                        (
                                                            <span>
                                                                <span style={{ border: '2px solid #000 !important', padding: '2px' }} title={"Expand Edit Mode"}><FontAwesomeIcon icon={['fas', 'expand-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                            </span>
                                                        )
                                                }
                                            </button>
                                            <span style={{ cursor: "pointer" }} onClick={() => {
                                                this.closeImportStockModal()
                                            }}>
                                                <FontAwesomeIcon icon={['fas', 'times']} size={'md'} />
                                            </span>
                                        </div>
                                    </>
                                }
                            </div>
                            <div class="modal-body" style={{ maxHeight: this.state.fullScreen ? '100vh' : "80vh", height: this.state.fullScreen ? '100vh' : '80vh' }}>
                                <div className="">
                                    <div className="row">
                                        <div className="col">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="import-header">
                                                    {
                                                        this.state.tabs.map((item, index) => {
                                                            return (
                                                                <div className="tab-wrapper"><span className={this.state.currentTab == index ? "circle-tab" : "circle-tab-muted"}>{index + 1}</span><p className={this.state.currentTab == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p></div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>

                                            {
                                                this.state.currentTab == 0 && this.chooseFileComponent()
                                            }
                                            {
                                                this.state.currentTab == 1 && this.importCSVFileComponent()
                                            }

                                            <div className="import-footer">
                                                {
                                                    this.state.currentTab == 1 &&

                                                    <div style={{ width: '100%', margin: '0px 10px 0 0' }}>

                                                        {
                                                            <div className="d-flex align-items-center flex-wrap" style={{ display: this.state.loadingImportProcess ? '' : 'none !important' }}>
                                                                {
                                                                    <>
                                                                        <ProgressBar bgcolor={"#6a1b9a"} completed={this.state.importProgressSummary['completed']} failed={this.state.importProgressSummary['failed']} total={this.state.importProgressSummary['total']} pending={this.state.importProgressSummary['pending']} />
                                                                        <p className="mb-0 font-weight-bold" style={{ fontSize: 14 }}>Import Progress: {(this.state.importProgressSummary['total'] - this.state.importProgressSummary['pending'])} | {this.state.importProgressSummary['total']}</p>
                                                                    </>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.currentTab == 0 && this.state.csvData.length > 0 && this.state.validations['isHeadersValid'] && (
                                                        <button type="button" className="btn import-btn" onClick={() => {
                                                            this.setState({
                                                                currentTab: 1
                                                            })
                                                        }}>
                                                            Proceed
                                                        </button>
                                                    )
                                                }
                                                {
                                                    this.state.currentTab == 1 && (
                                                        <>
                                                            {
                                                                this.state.validations['isVerified'] ?
                                                                    <span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
                                                                        <FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Verified
                                                                    </span>
                                                                    :
                                                                    resultPendingData?.length > 0 || resultFailedData?.length > 0 ?
                                                                        this.state.loadingImportProcess ? <ButtonLoader /> :
                                                                            <button type="button" className="btn import-btn" disabled={this.state.validations['isVerified']}
                                                                                onClick={() => {

                                                                                    let importProgressSummary = { completed: 0, failed: 0, total: this.state.postStockDetailsArray.length, pending: this.state.postStockDetailsArray.length }
                                                                                    this.setState({
                                                                                        loadingImportProcess: true,
                                                                                        importProgressSummary
                                                                                    }, () => {
                                                                                        this.apiCallToImportVerifyStockDetails(0, this.state.importProgressSummary)
                                                                                    })
                                                                                }

                                                                                }
                                                                            >
                                                                                Verify
                                                                            </button>

                                                                        : null
                                                            }

                                                            {/* {resultPendingData?.length > 0 || resultFailedData?.length > 0 ? */}
                                                            {(resultSuccessData?.length > 0 && (resultFailedData?.length == 0 || this.state.loadingImportProcess == false)) ?
                                                                this.state.loadingImportStockProcess ? <ButtonLoader /> :
                                                                    <>
                                                                        {this.state.isAlreadyScanned && <p>Resource is already scanned.</p>}
                                                                        < button type="button" className="btn import-btn" disabled={this.state.isImportButtonDisabled || this.state.isAlreadyScanned} onClick={() => {
                                                                            this.setState({
                                                                                loadingImportStockProcess: true
                                                                            }, () => {
                                                                                this.apiCallToScanManualStock(0)
                                                                            })
                                                                        }
                                                                        }>
                                                                            Import
                                                                        </button>
                                                                    </>
                                                                : null
                                                            }
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.importStockModal && <div className="modal-backdrop fade show"></div>}
            </>
        )
    }

    // export subscription details into excel format
    exportData = () => {
        // Define the CSV headers
        const headers = [
            "Accession Series*", "Accession Number*"
        ];

        // Adding sample hard-coded data
        const sampleData = [
            [
                "ACCSR1", "1"
            ],
            [
                "ACCSR2", "2"
            ]
        ];

        const fileName = 'Stock Details.xlsx';
        const rowData = [];

        // Loop through the Stock data and generate rows for the table
        sampleData.map(data => {
            const row = [
                data[0] || '',
                data[1] || '',
            ];


            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);

    };

    // download pre-requisite data in excel format
    exportPreRequisiteData = () => {
        // Define the CSV headers
        const headers = this.state.preRequisiteCSVHeadersForFaculty.map(header => header.label);
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty

        const fileName = 'PreRequisite_Stock_Details.xlsx';
        const rowData = [];

        // For accession Series Data
        if (Object.values(this.state.accessionSeriesList).length > 0) {
            Object.values(this.state.accessionSeriesList).map((data, index) => {
                if (data?.label != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].accessionSeries = data?.label
                    } else {
                        preRequisiteData.push({ accessionSeries: data?.label })
                    }
                }
            })
        }

        // Loop through the Stock data and generate rows for the table
        preRequisiteData.forEach(Stock => {
            const row = this.state.preRequisiteCSVHeadersForFaculty.map(header => {
                // Access each key dynamically from Stock using the header key
                return Stock[header.key] || ''; // If no value exists, return an empty string
            });

            // Add the row to the data
            rowData.push(row);
        });

        // Create the worksheet with headers and data
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rowData]);

        // Create a workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Write the file (download the .xlsx file)
        XLSX.writeFile(workbook, fileName);
    };

    // display excel data onchange of choose file
    handleExcelInput = (event) => {
        const file = event.target.files[0];

        const fileDetails = {
            name: file.name,
            lastModified: file.lastModified,
            lastModifiedDate: file.lastModifiedDate,
            webkitRelativePath: file.webkitRelativePath,
            size: file.size,
            type: file.type
        };


        this.setState({
            selectedCSVFiles: fileDetails
        })

        if (!file) {
            this.setState({
                successModalType: "error",
                successMessage: "No file selected.",
                isValidAttachment: false,
                successModal: true,
            });
            return;
        }

        if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
            file.type !== "application/vnd.ms-excel") {
            this.setState({
                selectedCSVFiles: {},
                successModalType: "error",
                successMessage: "Please select a valid Excel file.",
                isValidAttachment: false,
                successModal: true,
            })
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryData = e.target.result;
            const workbook = XLSX.read(binaryData, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

            this.processExcelData(sheetData);
        };

        reader.readAsBinaryString(file);
    }

    processExcelData = (sheetData) => {
        if (sheetData.length === 0) {
            this.setState({
                successModalType: "error",
                successMessage: "Excel file is empty.",
                isValidAttachment: false,
            });
            return;
        }

        const headers = sheetData[0];
        const rows = sheetData.slice(0);

        let postStockDetailsArray = [];
        let postStockHeadersArray = [];

        // // Validate headers
        if (headers != undefined && headers.length > 0) {
            headers.map((headerName, index) => {
                if (headerName != undefined && headerName.trim() !== "") {
                    postStockHeadersArray.push(headerName.trim());
                }
            })
        } else {
            toast.warn("Invalid headers found in imported excel file.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

        // Read Excel Actual Body Data including date
        if (postStockHeadersArray.length > 0) {
            rows.map((csvRow, index) => {
                if (index !== 0) {
                    let StockObject = {};

                    for (let i = 0; i < postStockHeadersArray.length; i++) {
                        let value = csvRow[i];

                        // Add the value to the Stock object
                        StockObject[postStockHeadersArray[i]] = value === undefined || value === null ? "" : value;
                    }

                    // Add the updated Stock object to the final array
                    postStockDetailsArray.push({
                        ...StockObject,
                        verificationStatus: "pending",
                        importStatus: "pending",
                        loading: false
                    });
                }
            });
        }

        this.setState({
            csvData: [...rows],
            postStockDetailsArray: postStockDetailsArray,
            postStockHeadersArray: postStockHeadersArray
        }, () => {
            this.validateCSVFileHeaders();

        })
    };

    // CHOOSE Stock COMPONENT
    chooseFileComponent = () => {
        return (
            <>
                <div className="import-info">
                    <div className="import-info-title ">
                        <p className="import-h5">Steps to import Stock Details:</p>
                    </div>
                    <ol className="instruction-list mt-2 mb-2">
                        <li>Stock Details can be imported in excel format.</li>
                        <li>Excel should be in specified format for import to work correctly.</li>
                        <li>* indicate mandatory fields.</li>
                        <li>
                            Refer the below example while adding content to the excel.  &nbsp;
                            {/* onClick={() => this.props.export()} */}
                            <span className="download-links font-weight-bold" onClick={() => this.exportData()}>
                                Download Sample Excel File
                                &nbsp;<FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {this.props.csvLoading &&
                                <span> &nbsp;<FontAwesomeIcon icon={['fas', 'circle-notch']} size={'md'} className='rotate' style={{ color: '#0465AC' }} /></span>
                            }
                        </li>
                        <li>Refer the prerequire data to import.
                            &nbsp;
                            <span
                                className={`download-links font-weight-bold ${(
                                    !this.state.loadingAccessionSeriesData) ? 'download-links' : 'disabledLink'}`}
                                onClick={(Stock) => {
                                    if (
                                        !this.state.loadingAccessionSeriesData
                                    ) {
                                        // Allow the download
                                        this.exportPreRequisiteData()
                                    } else {
                                        // Prevent the download
                                        Stock.preventDefault();
                                    }
                                }}
                            >
                                Download Prerequisite Excel File <FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                        </li>
                    </ol>

                    <div className="import-info-preview">
                        {
                            this.state.csvData.length > 0 ? (
                                <div className="table-responsive" style={{ overflowY: 'auto', height: '250px' }}>
                                    <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                        <thead>
                                            {
                                                this.state.postStockHeadersArray.map((item) => {
                                                    return (
                                                        <th>{item}</th>
                                                    )
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.postStockDetailsArray.map((item, index) => {
                                                    if (item != undefined) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    this.state.postStockHeadersArray.map((keys) => {
                                                                        if (typeof item[keys] == 'object') {
                                                                            return <td>{item[keys]['value']}</td>
                                                                        } else {
                                                                            return <td>{item[keys]}</td>
                                                                        }
                                                                    })
                                                                }

                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2">After choosing file, You can view content here.</p></span>
                        }

                    </div>

                </div>
                <div className="import-info-note mt-2 mb-3">
                    <p>Once you download the sample Excel file. Update the necessary content. In order to import the updated file you have to upload by clicking on the button mentioned below.</p>
                </div>
                <div className="import-body">
                    <div className="d-flex align-items-center flex-wrap">
                        <div style={{ display: "none" }}>
                            <form ref={this.myRef}>
                                <input
                                    type="file"
                                    id="react-excel-reader-input-Stock"
                                    accept=".xlsx, .xls"
                                    onChange={this.handleExcelInput}
                                    style={{ display: 'none' }}
                                />
                            </form>
                        </div>
                        <button type="button" className="btn import-btn" onClick={this.openFileInput} disabled={!config.institute_id}>
                            <FontAwesomeIcon icon={['fas', 'paperclip']} size={'lg'} color={"#FFF"}></FontAwesomeIcon> Choose File
                        </button>
                        {
                            Object.keys(this.state.selectedCSVFiles).length > 0 ?
                                <span>
                                    <span>
                                        {this.state.selectedCSVFiles['name']}
                                        <span style={{ "cursor": 'pointer' }} onClick={() => {
                                            this.removeCSVFile()
                                            this.myRef.current.reset()
                                        }}>
                                            <FontAwesomeIcon icon={['fas', 'times']} size={'md'}></FontAwesomeIcon>
                                        </span>
                                    </span>
                                </span>
                                : <p className="mb-0"><span className="text-danger">*</span> Please choose your excel file to import stock details</p>
                        }
                    </div>
                </div>
                {
                    this.state.csvData.length > 0 && !this.state.validations['isHeadersValid'] &&
                    <div className="alert alert-danger" style={{ maxHeight: '20vh', overflow: "auto" }}>
                        {
                            Object.values(this.state.validations['headersErrors']).map((item) => {
                                return <p className="text-danger my-2">Header {item.cell}-{item.message}</p>
                            })
                        }
                    </div>
                }
            </>
        )
    }

    // IMPORT CSV FILE COMPONENT 
    importCSVFileComponent = () => {
        return (
            <>
                <div className="previw-sheet" style={{ minHeight: '40vh' }}>
                    {
                        this.state.csvData.length > 0 ? (
                            <div className="table-responsive" >
                                <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                    <thead>
                                        <th className="td-dense">{"Sr. No."}</th>
                                        <th className="td-dense">{"Status"}</th>
                                        {/* {this.state.currentProgress == 0 ? "Error Location" : } */}
                                        {
                                            this.state.postStockHeadersArray.map((item) => {
                                                return (
                                                    <th className="td-dense">
                                                        {item === 'Title' ? (
                                                            <>
                                                                {item} <span className="text-danger">*</span>
                                                            </>
                                                        ) : (
                                                            item
                                                        )}
                                                    </th>
                                                )
                                            })
                                        }
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.postStockDetailsArray.map((item, index) => {
                                                if (item != undefined) {
                                                    return (

                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td className="td-dense">
                                                                {
                                                                    this.getCurrentStatusComponent(index, item['verificationStatus'], item['importStatus'])
                                                                }
                                                            </td>

                                                            {
                                                                this.state.postStockHeadersArray.map((keys, cellIndex) => {
                                                                    // single select dropdown check
                                                                    let isSingleSelectValid = true;
                                                                    let dropdownOptions = [];

                                                                    if (keys === "Accession Series*") {
                                                                        dropdownOptions = Object.values(this.state.accessionSeriesList).map(opt => opt.label);
                                                                        isSingleSelectValid = dropdownOptions.includes(item[keys]);
                                                                        // If invalid, clear the field
                                                                        if (!isSingleSelectValid) {
                                                                            item["Accession Series*"] = '';
                                                                        }
                                                                    }

                                                                    return (
                                                                        <td className={this.state.currentErrorObject['row'] == index ? "td-dense-highlight" : "td-dense"}>
                                                                            <div className={this.state.currentErrorObject['row'] == index ? "table-row-highlighter" : ""}>
                                                                                {
                                                                                    keys == "Accession Series*" ?
                                                                                        <>
                                                                                            <select
                                                                                                id="series-selction"
                                                                                                value={item[keys]} // Set the selected value
                                                                                                className="form-control"
                                                                                                onChange={(e) => {
                                                                                                    this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                                }}
                                                                                                style={{
                                                                                                    width: "max-content"
                                                                                                }}
                                                                                            >
                                                                                                <option value="">{item[keys] ? `Select ${keys}` : keys}</option>

                                                                                                {/* When keys are "Accession Series*" */}
                                                                                                {keys === "Accession Series*" &&
                                                                                                    Object.values(this.state.accessionSeriesList).map((data) => {
                                                                                                        const label = data.label.length > 20 ? data.label.slice(0, 20) + '...' : data.label;
                                                                                                        return (
                                                                                                            <option key={data.value} value={data.label} title={data.label}>
                                                                                                                {label}
                                                                                                            </option>
                                                                                                        );
                                                                                                    })
                                                                                                }
                                                                                            </select>

                                                                                            {!isSingleSelectValid && (
                                                                                                <span className="text-danger">Please select valid {keys}</span>
                                                                                            )}
                                                                                        </>
                                                                                        :
                                                                                        <input
                                                                                            type='text'
                                                                                            placeholder={`Enter ${keys}`}
                                                                                            value={item[keys]}
                                                                                            ref={(el) => this.tableObject[`${index}-${cellIndex}`] = el}
                                                                                            style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                                                            className="form-control filterInput"
                                                                                            onChange={(e) => {
                                                                                                const value = e.target.value;

                                                                                                // If field is "Year of Publication", validate input
                                                                                                if (keys === 'Year of Publication') {
                                                                                                    const isValid = /^\d{0,4}(-(\d{0,2}|\d{0,4}))?$/.test(value);
                                                                                                    if (!isValid) return; // Block invalid input
                                                                                                }

                                                                                                this.getValueOfRowInputs(index, keys, value, keys);
                                                                                            }}
                                                                                        />
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                }
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                        ) : <p>Data is not available.</p>
                    }
                </div>
                <p><span className="text-danger my-2 font-size14">*</span>Note : Errors are indicated by red boxes. Please click on the red boxes to correct them. </p>

                <div className="inspect-console">
                    <div className="table-responsive">
                        <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        <div className="import-progress">
                                            {
                                                this.state.importProgress.map((item, index) => {
                                                    return (
                                                        <div className="tab-wrapper">
                                                            <div className="step-wrapper">
                                                                <span className={this.state.currentProgress == index ? "circle-tab" : "circle-tab-muted"} style={this.checkImportTabProgress(index) ? { background: "green", color: "#FFF" } : {}}>{index + 1}</span>
                                                                {index < this.state.importProgress.length - 1 && <span className={this.state.validations['isVerified'] ? "step-line bg-success" : "step-line "}></span>}
                                                            </div>
                                                            <p className={this.state.currentProgress == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p>
                                                        </div>

                                                    )
                                                })
                                            }
                                        </div>
                                    </th>

                                    <th>
                                        <div className="d-flex justify-content-between align-items-center" >
                                            <span onClick={() => {
                                                this.state.currentPointer > 0 && this.navigateToPreviousError()
                                            }} disabled={true} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-left']} size="md"></FontAwesomeIcon></span>
                                            <p className="mb-0 font-weight-bold">Error Location :
                                                {Object.keys(this.state.currentErrorObject).length > 0 &&
                                                    `Rows : ${this.state.currentErrorObject['row'] + 1} Columns : ${this.state.currentErrorObject['key']}`
                                                }
                                            </p>
                                            <span onClick={() => {
                                                this.state.currentPointer < this.state.errorLogs.length && this.navigateToNextError()
                                            }} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-right']} size="md"></FontAwesomeIcon></span>
                                        </div>
                                    </th>
                                </tr>
                                <tr>

                                    <th align="center" style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        {
                                            this.state.errorLogs.length > 0 ?
                                                (
                                                    <div>{this.ErrorViewConsole()}</div>
                                                )
                                                : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2 mb-0">After verification, You can view content which has errors.</p></span>
                                        }
                                        {/* 
										{
											this.state.errorMessageObjArray?.length > 0 ?
												this.state.errorMessageObjArray?.map((row) => {
													let rowIndex = row['rowIndex'];
													let message = row['message'];
													return <div>Row : {rowIndex} | Error : {message}</div>;
												})
												:
												<span className="initial-preview">
													<FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999" />
													<p className="mx-2 mb-0">After verification, You can view content which has errors.</p>
												</span>
										} */}

                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </>
        )
    }

    // 	GET CURRENT STATUS COMPONENT
    getCurrentStatusComponent = (index, verificationStatus = "pending", importStatus = "pending") => {
        {
            return this.state.importPointer['rowindex'] == index ?
                <div>
                    {
                        this.state.importPointer['loading'] ?
                            <div class="spinner-border spinner-border-sm" role="status" >
                                <span class="sr-only">{this.state.importPointer['status']}...</span>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>{this.state.importPointer['status'].charAt(0).toUpperCase() + this.state.importPointer['status'].slice(1)}</div>
                                {/* <div>{this.state.importPointer['status']}</div> */}
                                {/* {
                                    this.state.importPointer['status'] == 'failed' &&
                                    // importStatus == 'failed' &&
                                    <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                                        this.setState({
                                            loadingImportProcess: true
                                        }, () => {
                                            this.apiCallToImportVerifyStockDetails(index, this.state.importProgressSummary, 'true')
                                        })
                                    }>
                                        Retry
                                    </button>
                                } */}
                            </div>

                    }

                </div>

                : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div>{importStatus.charAt(0).toUpperCase() + importStatus.slice(1)}</div>

                    {/* {
                        // this.state.importPointer['status'] == 'failed' &&
                        importStatus == 'failed' &&
                        <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                            this.setState({
                                loadingImportProcess: true
                            }, () => {
                                this.apiCallToImportVerifyStockDetails(index, this.state.importProgressSummary, 'true')
                            })
                        }>
                            Retry
                        </button>
                    } */}
                </div>
        }
    }

    //function to download prerequisite data 
    downloadPrerequisitedataCSV = () => {
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }
    // Strip HTML
    stripHtml(html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    //FUNCTION DEFINED TO GET THE INPUT OF THE IMPORTED CSV
    handleCSVInput = (csvData, fileInformation) => {

        this.setState({
            selectedCSVFiles: fileInformation
        })

        if (fileInformation.type !== "text/csv") {
            this.setState({
                selectedCSVFiles: {},
                successModal: true,
                successModalType: "error",
                successMessage: "Please select csv file.",
                isValidAttachment: false
            })
        } else {
            let postStockDetailsArray = [];
            let postStockHeadersArray = [];

            if (csvData.length > 0) {
                csvData = csvData.filter((rowArray, index) => rowArray.length > 1 && !rowArray.every((val) => val == ""));

                // Read CSV Headers
                let headers = csvData[0];

                if (headers != undefined && headers.length > 0) {
                    headers.map((headerName, index) => {
                        if (headerName != undefined) {
                            postStockHeadersArray.push(headerName.trim());
                        }
                    })
                }

                // Read CSV Actual Body Data
                if (postStockHeadersArray.length > 0) {
                    csvData.map((csvRow, index) => {
                        if (index != 0) {
                            let challanObject = {};
                            let totalDeduction = 0;

                            for (let i = 0; i < postStockHeadersArray.length; i++) {

                                if (csvRow[i] == undefined || csvRow[i] == null || csvRow[i] == "") {
                                    challanObject[postStockHeadersArray[i]] = "";
                                } else {
                                    challanObject[postStockHeadersArray[i]] = csvRow[i];
                                }
                            }

                            if (challanObject['Gross Pay'] != undefined) {
                                challanObject['Net Pay'] = parseFloat(challanObject['Gross Pay']) - totalDeduction;
                            }

                            postStockDetailsArray.push({ ...challanObject, verificationStatus: "pending", importStatus: "pending", loading: false });
                        }
                    })
                }
            }

            this.setState({
                csvData: [...csvData],
                postStockDetailsArray: postStockDetailsArray,
                postStockHeadersArray: postStockHeadersArray
            }, () => {
                this.validateCSVFileHeaders();

            })
        }
    }

    // VALIDATE CSV FILE HEADERS
    validateCSVFileHeaders = () => {
        let commonHeaders = [
            "Accession Series*", "Accession Number*",
        ]
        let mandatoryHeaders = ["Accession Series*", "Accession Number*"]
        let postStockHeadersArray = this.state.postStockHeadersArray;
        let validations = this.state.validations;

        if (postStockHeadersArray.length > 0) {
            // Checking Default Stock Headers are available or not.
            mandatoryHeaders.map((header, index) => {
                if (!postStockHeadersArray.includes(header)) {
                    let validationObject = {
                        touch: true,
                        cell: index + 1,
                        row: 0,
                        status: "error",
                        message: `${header} is mandatory column to import stock.`,
                        type: "header",
                        errorCount: 0
                    }
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }
            })

            // Checking Dyanamic Stock Headers are available or not.
            postStockHeadersArray.map((key, index) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    status: "error",
                    message: "",
                    type: "header",
                    errorCount: 0
                }

                let isValidHeader = commonHeaders.some((keys) => {
                    return keys == key.trim();
                })

                let validationMessage = '';
                if (key) {
                    validationMessage = ` ${key} header is invalid.`
                } else {
                    validationMessage = ` ${key} header is missing.`
                }

                if (!isValidHeader) {
                    validationObject.cell = index;
                    validationObject.status = "error";
                    validationObject.message = `Please check default headers. ${validationMessage}`;
                    validationObject.touch = true;
                }


                if (validationObject.touch) {
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }

            })
        }


        if (validations['headersErrors'].length == 0) {
            validations['isHeadersValid'] = true;
        }

        this.setState({
            validations: { ...validations }
        })
    }

    // VALIDATE CSV FILE DATA
    validateCSVFileData = () => {
        let postStockDetailsArray = this.state.postStockDetailsArray;
        let postStockHeadersArray = this.state.postStockHeadersArray;
        let validations = { ...this.state.validations, dataErrors: {}, errors: [], isDataValid: false, isVerified: false };
        let verificationSummary = {
            completed: 0,
            failed: 0,
            total: 0,
            pending: 0
        };

        verificationSummary['total'] = postStockDetailsArray.length;
        verificationSummary['pending'] = postStockDetailsArray.length;
        let verificationPointer = this.state.verificationPointer;

        postStockDetailsArray.map((item, rowIndex) => {
            let status = true;
            let hasEarning = true;
            verificationPointer['loading'] = true;
            verificationPointer['status'] = 'verfying';
            verificationPointer['rowindex'] = rowIndex;
            this.setState({
                verificationPointer: verificationPointer
            })

            verificationSummary['pending'] -= verificationSummary['pending'];

            postStockHeadersArray.map((key, cellIndex) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "",
                    type: "data",
                    errorCount: 0
                }

                if (validationObject.touch) {
                    status = false;
                    if (validations['dataErrors'][rowIndex] == undefined) {
                        validations['dataErrors'][rowIndex] = {};
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;

                    } else {
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;
                    }
                    item['verificationStatus'] = "failed";
                    validations['isDataValid'] = false;
                }
            })

            if (hasEarning) {
                validations['errors'].push({
                    touch: true,
                    cell: 0,
                    row: rowIndex,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "Please enter atleast one earning component",
                    type: "basic",
                    errorCount: 1
                })

                verificationPointer['status'] = 'failed';
                postStockDetailsArray[rowIndex]['verificationStatus'] = 'failed';
                verificationPointer['loading'] = false;
            } else {
                verificationPointer['status'] = status ? 'verified' : 'failed';
                postStockDetailsArray[rowIndex]['verificationStatus'] = verificationPointer['status'];
                verificationPointer['loading'] = false;
            }

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];

            this.setState({
                postStockDetailsArray: [...postStockDetailsArray],
                verificationProgress: verificationSummary,
                verificationPointer: verificationPointer,
            })
        })

        if (validations['errors'].length > 0) {
            let failedCount = 0;
            validations['errors'].map(item => {
                if (!Object.keys(validations['dataErrors']).includes(item.row)) {
                    failedCount++;
                }
            })

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length + failedCount;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];
        }


        if (Object.keys(validations['dataErrors']).length == 0 && validations['errors'].length == 0) {
            validations['isDataValid'] = true;
            validations['isVerified'] = true;
            this.setState({
                currentPointer: 1
            })
        }

        this.setState({
            validations: { ...validations },
            verificationProgress: verificationSummary,
            loadingVerificationProcess: false
        }, () => {
            this.getBugLogs();
        })
    }

    // GET VALUES FORM INPUT FIELDS
    getValueOfRowInputs = (rowIndex, key, value, type) => {
        let postStockDetailsArray = this.state.postStockDetailsArray;
        let rowObject = postStockDetailsArray[rowIndex];
        

        // Handle other cases
        if (typeof rowObject[key] == 'object') {
            rowObject[key]['value'] = value; // Update nested value if it's an object
        } else {
            rowObject[key] = value; // Update directly if it's a primitive
        }

        postStockDetailsArray[rowIndex] = rowObject;

        this.setState({
            postStockDetailsArray: postStockDetailsArray
        });
    }

    // GET VALUES FORM Multi-Select FIELDS
    getValueOfMultipleSelect = (rowIndex, key, selectedOptions) => {
        let postStockDetailsArray = this.state.postStockDetailsArray;
        let rowObject = postStockDetailsArray[rowIndex];

        // If the selected options are not empty, update the row object with the selected values
        if (selectedOptions && selectedOptions.length > 0) {
            rowObject[key] = selectedOptions.map(option => option.value); // Set selected values as an array
        } else {
            rowObject[key] = []; // If no options are selected, set it to an empty array
        }

        postStockDetailsArray[rowIndex] = rowObject;

        this.setState({
            postStockDetailsArray: postStockDetailsArray
        });
    }

    // Navigate to previous 
    navigateToPreviousError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer > 0) {
            currentPointer -= 1;
            currentErrorObject = errorLogs[currentPointer];
            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }

    }

    // Navigate to next
    navigateToNextError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer < errorLogs.length - 1) {

            currentPointer += 1;
            currentErrorObject = errorLogs[currentPointer];

            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }
    }

    // CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
            successModalType: "",
            successMessage: ""
        })
    }

    // CONSOLE ERROR 
    ErrorViewConsole = () => {
        let { row, message } = this.state.currentErrorObject;
        return (
            <div>
                {
                    this.state.currentErrorObject['key'] != "" && (
                        <div>
                            <p className="mb-0 font-weight-bold text-danger">{this.state.currentErrorObject['message']}</p>
                        </div>
                    )

                }
            </div>
        )
    }

    // API CALL TO IMPORT VERIFY Stock
    apiCallToImportVerifyStockDetails = async (rowIndex = 0, importProgressSummary = { completed: 0, failed: 0, total: 0, pending: 0 }, isRetry = "") => {

        if (rowIndex < this.state.postStockDetailsArray.length) {
            let StockData = this.state.postStockDetailsArray[rowIndex];

            let importPointer = this.state.importPointer;
            importPointer['loading'] = true;
            importPointer['status'] = 'importing';
            importPointer['rowindex'] = rowIndex;
            this.setState({
                importPointer: importPointer,
            })

            let errorLogs = this.state.errorLogs;

            let accessionSeriesName = StockData['Accession Series*'] ? StockData['Accession Series*'] : "";
            let accessionNumber = StockData['Accession Number*'] ? StockData['Accession Number*'] : "";

            let requestData = {
                "iid": config.institute_id,
                "facultyId": config.faculty_id,
                "library_resource_stock_verification_id": this.state.selectedStockVerification.uniqueId,
                "accessionNumber": accessionNumber,
                "accessionSeriesName": accessionSeriesName || ''
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_VerifyAccessionDetails',
                requestData,
                "/api/library/stockVerification.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToImportVerifyStockDetails(rowIndex, importProgressSummary, isRetry);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;        
        
                    this.setState({
                        verifyImportResourceResult: apiResult,
                        isAlreadyScanned: apiResult.status === 'success' &&
                            apiResult.message === 'Resource is already scanned.'
                    })
                    if (apiResult.status == 'success') {
                        // Show warning toast only for already scanned
                        if (this.state.isAlreadyScanned) {
                            toast.warn(apiResult.message, {
                                position: "top-right",
                                autoClose: 2000,
                            });
                        }
                        
                        let postStockDetailsArray = this.state.postStockDetailsArray;
                        let rowItem = postStockDetailsArray[rowIndex];

                        rowItem['status'] = 'completed'
                        postStockDetailsArray[rowIndex] = rowItem;

                        importProgressSummary['completed'] += 1;
                        if (isRetry != "true") {

                            importProgressSummary['pending'] -= 1;
                        } else {
                            importProgressSummary['failed'] -= 1;
                        }

                        importPointer['status'] = 'success';
                        postStockDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;


                        let findIndex = errorLogs.findIndex(obj => obj.row == rowIndex)

                        if (findIndex != -1) {
                            errorLogs.splice(findIndex, 1);
                        }

                        this.setState({
                            postStockDetailsArray: postStockDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentPointer: 0,
                            currentErrorObject: errorLogs.length > 0 ? errorLogs[0] : {}
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifyStockDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                    else {
                        // let rowIndex = rowIndex + 1;
                        let errorObj = {};
                        errorObj['row'] = rowIndex;
                        errorObj['key'] = apiResult.key;
                        errorObj['message'] = apiResult.message;

                        let foundIndex = errorLogs.findIndex(obj => obj.row == rowIndex);
                        if (foundIndex != -1) {
                            errorLogs[foundIndex] = errorObj;
                        }
                        else {
                            errorLogs.push(errorObj);
                        }
            
                        let postStockDetailsArray = this.state.postStockDetailsArray;
                        let rowItem = postStockDetailsArray[rowIndex];
                        rowItem['status'] = 'failed';
                        postStockDetailsArray[rowIndex] = rowItem;
                        if (isRetry != "true") {
                            importProgressSummary['failed'] += 1;
                            importProgressSummary['pending'] -= 1;
                        }

                        importPointer['status'] = 'failed';

                        postStockDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;

                        this.setState({
                            postStockDetailsArray: postStockDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentErrorObject: errorLogs[0],
                            currentPointer: 0,
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifyStockDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                }
                else {
                    let postStockDetailsArray = this.state.postStockDetailsArray;
                    importProgressSummary['failed'] += 1;
                    importPointer['status'] = 'failed';
                    postStockDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                    importPointer['loading'] = false;

                    this.setState({
                        postStockDetailsArray: postStockDetailsArray,
                        importProgressSummary: importProgressSummary,
                        importPointer: importPointer,
                        currentPointer: 0,
                    }, () => {

                        if (isRetry != "true") {

                            this.apiCallToImportVerifyStockDetails(rowIndex + 1, importProgressSummary, isRetry);
                        }
                    })

                }
            }

        } else {
            this.setState({
                loadingImportProcess: false
            })
        }
    }

    // API CALL TO IMPORT Stock
    apiCallToScanManualStock = async (rowIndex = 0, importProgressSummary = { completed: 0, failed: 0, total: 0, pending: 0 }, isRetry = "") => {

        if (rowIndex < this.state.postStockDetailsArray.length) {
            let StockData = this.state.postStockDetailsArray[rowIndex];

            let accessionSeriesItemValue = [];

            // accession series id
            accessionSeriesItemValue = Object.values(this.state.accessionSeriesList)
                .filter(item => item.label === StockData['Accession Series*'])
                .map(({ value, label }) => ({ value, label }));

            let accessionSeriesName = accessionSeriesItemValue.length > 0 ? accessionSeriesItemValue[0].value : "";
            let accessionNumber = StockData['Accession Number*'] ? StockData['Accession Number*'] : "";

            let requestData = {
                "iid": config.institute_id,
                "facultyId": config.faculty_id,
                "library_resource_stock_verification_id": this.state.selectedStockVerification.uniqueId,
                "barcode_text": accessionNumber,
                "selectedAccessionsKey": accessionSeriesName || ''
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'addScannedResourceInStockVerification',
                requestData,
                "/api/library/stockVerification.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToScanManualStock(rowIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    this.setState({ stockScannedStockApiResponse: apiResult });

                    if (apiResult.status == 'success') {
                        this.apiCallToScanManualStock(rowIndex + 1);
                    }
                    else {
                        toast.warn(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.apiCallToScanManualStock(rowIndex + 1);
                    }
                }
                else {
                    toast.error('Something went wrong while updating Stock. Please try again later.', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToScanManualStock(rowIndex + 1);
                }
            }

        } else {
            this.setState({
                loadingImportStockProcess: false,
                isImportButtonDisabled: true
            })

            // common success message
            toast.success(this.state.stockScannedStockApiResponse?.message || "Stock data added successfully.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            // CORRECT CALL
            if (typeof this.props.refreshScannedStockList === "function") {
                this.props.refreshScannedStockList();
            }
        }
    }

    checkImportStatus = () => {
        return this.state.postStockDetailsArray.some((item, index) => item.importStatus == 'success')
    }

    checkImportTabProgress = (index) => {
        if (index == 0) {
            return this.state.validations['isVerified']
        } else if (index == 1) {
            return this.checkImportStatus()
        }
    }

    render() {
        return (
            <>
                {this.importStockModal()}

                <SuccessModal
                    successModal={this.state.successModal}
                    successModalType={this.state.successModalType}
                    successMessage={this.state.successMessage}
                    closeSuccessModal={this.closeSuccessModal}
                />

            </>
        )
    }
}

const ProgressBar = (props) => {
    const { bgcolor, completed, failed, pending, total } = props;

    let pendingProgressWidth = parseFloat(((pending / total) * 100).toFixed(2));
    let completedProgressWidth = parseFloat(((completed / total) * 100).toFixed(2));
    let failedProgressWidth = parseFloat(((failed / total) * 100).toFixed(2));


    const containerStyles = {
        // height: 15,
        width: '100%',
        backgroundColor: "#e0e0de",
        margin: '0.2em 0',
        display: 'flex',

    }

    const fillerStyles = {
        height: '100%',
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: 'width 1s ease-in-out',
    }

    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px'
    }
    const completedProgress = {
        width: `${completedProgressWidth}%`,
        backgroundColor: 'green'
    }


    const failedProgress = {
        width: `${failedProgressWidth}%`,
        backgroundColor: 'tomato'
    }

    const pendingProgress = {
        width: `${pendingProgressWidth}%`,
        backgroundColor: 'orange'
    }
    return (
        <div style={containerStyles}>
            {
                total > 0 && (<>
                    <div style={{ ...fillerStyles, ...completedProgress }}>
                        <span style={labelStyles}>{`${completedProgressWidth}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...failedProgress }}>
                        <span style={labelStyles}>{`${failedProgressWidth}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...pendingProgress }}>
                        <span style={labelStyles}>{`${pendingProgressWidth}%`}</span>
                    </div>
                </>)
            }

        </div>
    );
};


const mapStateToProps = store => {
    return {
        // VARIABLES TO GET admin DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};

export default connect(mapStateToProps)(ImportStock);